module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result30-1384d0bf0b122a7cf34d20ed71cb24f4.png";